import { Checkbox, CheckboxProps as MuiCheckboxProps, FormControlLabel } from '@mui/material'
import React, { ReactNode } from 'react'

export type C1CheckboxProps = MuiCheckboxProps & { id: string; label: ReactNode }

export const C1Checkbox = ({ id, label, ...props }: C1CheckboxProps): React.ReactElement => {
    return <FormControlLabel key={id} control={<Checkbox id={id} value={id} {...props} />} label={label} />
}
